import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef } from 'react';
import { css, styled, typography } from '../../../../../foundation';
import { PickerBaseIconButton } from '../../styles';
import { HALF_DAY_HOURS, RcTimePickerIconWidths } from '../utils';
var _StyledTimeIconButton = forwardRef(function (_a, ref) {
    var itemLength = _a.itemLength, wrapperSize = _a.wrapperSize, rest = __rest(_a, ["itemLength", "wrapperSize"]);
    return React.createElement(PickerBaseIconButton, __assign({ ref: ref }, rest));
});
export var StyledTimeIconButton = styled(_StyledTimeIconButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  && {\n    ", ";\n\n    ", ";\n  }\n"], ["\n  && {\n    ",
    ";\n\n    ",
    ";\n  }\n"])), function (_a) {
    var wrapperSize = _a.wrapperSize, itemLength = _a.itemLength;
    var iconWidth = RcTimePickerIconWidths[wrapperSize];
    if (itemLength > HALF_DAY_HOURS) {
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          width: ", ";\n          height: ", ";\n        "], ["\n          width: ", ";\n          height: ", ";\n        "])), iconWidth.s12, iconWidth.s24);
    }
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        width: ", ";\n        height: ", ";\n      "], ["\n        width: ", ";\n        height: ", ";\n      "])), iconWidth.s12, iconWidth.s12);
}, function (_a) {
    var wrapperSize = _a.wrapperSize;
    return typography(wrapperSize === 'medium' ? 'title1' : 'subheading1');
});
var templateObject_1, templateObject_2, templateObject_3;
